﻿export const DmaAppConstants = {
    name: "Aurum Data Management"
}